import { useState } from "react";
import LabelsLayout from "../componants/labels/LabelsLayout";

import LabelSearchForm from "../componants/labels/LabelSearchForm";
import LabelBreadcrumb from "../componants/labels/LabelBreadcrumb";
import { useNavigate } from "react-router-dom";

const options = [
  { id: "Certificats", name: "Certificats" },
  { id: "Certificats refusés", name: "Certificats refusés" },
];

export default function CertificatPromotSearch() {
  const [isOpen, setIsOpen] = useState(true);
  const [selected, setSelected] = useState("Certificats");
  const navigate = useNavigate();

  const toggleOpen = () => setIsOpen((prev) => !prev);

  const [formData, setFormData] = useState({
    organisme: "",
    entityId: "",
    entityName: "",
    version: "",
    reference: "",
    types: "",
    startDate: "",
    endDate: "",
    status: "",
  });

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const searchHandler = () => {
    navigate("/certificats/promot", {
      state: formData,
    });
  };

  const intialisationHandler = () => {
    setFormData({
      organisme: "",
      entityId: "",
      entityName: "",
      version: "",
      reference: "",
      types: "",
      startDate: "",
      endDate: "",
      status: "",
      isHistory: false,
    });
  };

  return (
    <LabelsLayout>
      <section className="container mx-auto">
        <LabelBreadcrumb title={"Certificats Promoteurs"} />
        <div className=" pt-5 pb-10 px-6">
          <LabelSearchForm
            intialisationHandler={intialisationHandler}
            selected={selected}
            setSelected={setSelected}
            isOpen={isOpen}
            toggleOpen={toggleOpen}
            options={options}
            formData={formData}
            handleChange={handleChange}
            searchHandler={searchHandler}
          />
        </div>{" "}
      </section>
    </LabelsLayout>
  );
}
